import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const BoxStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: '4px',
  paddingTop: '24px',
});
